const SHOP_NAME = process.env.REACT_APP_SHOP_NAME;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

export const shopifyLogin = () => {
    const oauthURL = `https://${SHOP_NAME}.myshopify.com/admin/oauth/authorize?client_id=${CLIENT_ID}&scope=read_orders,write_orders,read_customers&redirect_uri=${REDIRECT_URI}`;
    window.location.href = oauthURL; // Redirect to Shopify login
};

// ✅ Function to Get Token from LocalStorage
export const getShopifyToken = () => {
    return localStorage.getItem("shopifyToken") || null;
};

// ✅ Function to Store Token in LocalStorage
export const storeShopifyToken = (token) => {
    localStorage.setItem("shopifyToken", token);
};

// ✅ Function to Extract and Store Token from URL After Redirect
export const extractAndStoreToken = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromURL = urlParams.get("token");

    if (tokenFromURL) {
        storeShopifyToken(tokenFromURL); // ✅ Save token
        window.history.replaceState({}, document.title, "/"); // ✅ Clean URL
        return tokenFromURL;
    }

    return getShopifyToken(); // Return stored token if no new token found
};

export default extractAndStoreToken;